const INSTAGRAM_MEDIA_PATTERN =
  /^https?:\/\/(www\.)?instagram\.com\/(reel|p|tv)\/[A-Za-z0-9_-]+\/?(\?.*)?$/i

export function isValidInstagramMediaUrl(url: string): boolean {
  return INSTAGRAM_MEDIA_PATTERN.test(url.trim())
}

/** Canonical Instagram post/reel URL for storage and embeds. */
export function normalizeInstagramMediaUrl(url: string): string | null {
  const trimmed = url.trim()
  const match = trimmed.match(
    /instagram\.com\/(reel|p|tv)\/([A-Za-z0-9_-]+)/i
  )
  if (!match) return null
  const [, kind, shortcode] = match
  return `https://www.instagram.com/${kind}/${shortcode}/`
}

export function instagramEmbedUrl(url: string): string | null {
  const normalized = normalizeInstagramMediaUrl(url)
  if (!normalized) return null
  return `${normalized.replace(/\/$/, '')}/embed`
}

export function instagramMediaKind(url: string): 'reel' | 'post' | 'igtv' | null {
  const match = url.match(/instagram\.com\/(reel|p|tv)\//i)
  if (!match) return null
  const kind = match[1].toLowerCase()
  if (kind === 'reel') return 'reel'
  if (kind === 'p') return 'post'
  return 'igtv'
}

export function instagramProfileUrl(handle?: string): string {
  const value = handle?.trim()
  if (!value) return 'https://instagram.com/ooudkraft'
  if (value.startsWith('http')) return value
  const slug = value.replace(/^@/, '')
  return `https://instagram.com/${slug}`
}

export function instagramProfileLabel(handle?: string): string {
  const value = handle?.trim()
  if (!value) return '@ooudkraft'
  if (value.startsWith('@')) return value
  if (value.startsWith('http')) {
    const slug = value.replace(/^https?:\/\/(www\.)?instagram\.com\/?/i, '').replace(/\/$/, '')
    return slug ? `@${slug}` : '@ooudkraft'
  }
  return `@${value}`
}
